module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("c5VS0"))).then(() => parcelRequire('g3q1t'));